

import { Suspense, useEffect, useState } from "react";



export default function ArtSuperAdminLoader() {
  const [GatewayComponent, setGatewayComponent]: any = useState(null);
  useEffect(() => {
    async function loadModule() {
      try {
        const module = await import("art_superadmin/super_admin_gateway");
        setGatewayComponent(() => module.default);
      } catch (error) {
        console.error("Remote module 'art_superadmin' failed to load. Falling back.");
        setGatewayComponent(() => () => <div>Feature Unavailable</div>);
      }
    }

    loadModule();
  }, []);

  if (!GatewayComponent) return <div>Loading Gateway...</div>;
  return (
    <Suspense fallback={<div>Loading Gateway...</div>}>
      <GatewayComponent />
    </Suspense>
  );
}
